import React, { memo } from 'react'

const IconDelete = ({ color = "#DC143C", ...props }) => (
    <svg {...props} width="16" height="18" viewBox="0 0 16 18" fill="none">
        <path d="M0.75 3.75H15.25M4.75 3.75V2.75C4.75 1.64543 5.64543 0.75 6.75 0.75H9.25C10.3546 0.75 11.25 1.64543 11.25 2.75V3.75M10.25 7.75V13.25M5.75 7.75V13.25M1.75 3.75H14.25L13.6049 15.3609C13.5461 16.4208 12.6695 17.25 11.608 17.25H4.39197C3.3305 17.25 2.45393 16.4208 2.39505 15.3609L1.75 3.75Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export default memo(IconDelete)